import { NgClass } from '@angular/common';
import {
  Component,
  input,
  output,
  inject,
  signal,
  HostListener,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { ButtonComponent, IconButtonComponent, Icon, IconButtonIconFontSize } from '@claas/claas-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs';
import { INotification } from '@cde-fe-app/app/shared/models/notification.model';
import { EventTrackingService } from '@cde-fe-app/app/shared/services/event-tracking.service';
import { NotificationsService } from '@cde-fe-app/app/shared/services/notifications.service';
import { NotificationTileComponent } from '../notification-tile/notification-tile.component';

@Component({
  selector: 'app-notifications-panel',
  templateUrl: './notifications-panel.component.html',
  styleUrls: ['./notifications-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    IconButtonComponent,
    MatProgressSpinner,
    NgClass,
    NotificationTileComponent,
    TranslateModule,
  ],
})
export class NotificationsPanelComponent {
  readonly router = inject(Router);
  readonly notificationsService = inject(NotificationsService);
  readonly elem = inject(ElementRef);
  readonly eventTrackingService = inject(EventTrackingService);

  public notifications = input<INotification[] | null>();
  public notificationsLoading = input<boolean>();
  public newNotificationsCount = input<number | undefined>();

  public getNotifications = output<void>();

  public closeIcon: Icon = {
    iconId: '648548',
    namespace: 'cc',
    size: 24,
    iconStyle: 'bold',
  };

  isOpen = signal(false);
  initialToggle = true;
  protected readonly iconButtonIconFontSize = IconButtonIconFontSize;

  @HostListener('document:click', ['$event.target'])
  documentClicked(event: EventTarget | null) {
    if (event != null && !this.elem.nativeElement.contains(event)) {
      this.isOpen.set(false);
    }
  }

  navigateToNotifications() {
    this.isOpen.set(false);
    void this.router.navigate(['notifications']);
  }

  toggleSidebar() {
    const isOpen = this.isOpen();

    if (!isOpen) {
      this.eventTrackingService.eventTrackNew({
        payload: {
          event: 'machinemgtevent',
          eventCategory: 'Machine Management Header',
          eventAction: 'Click Button',
          eventName: 'Open notification',
        },
      });
    }

    if (this.initialToggle && isOpen) {
      this.initialToggle = false;
      this.notificationsService
        .updateLastVisitToNotification()
        .pipe(take(1))
        .subscribe(() => {
          this.getNotifications.emit();
        });
    }

    this.isOpen.set(!isOpen);
  }
}
